import {useAuth0, withAuthenticationRequired} from "@auth0/auth0-react";
import Loading from "../../common/Loading";
import React from "react";
import {Button, Card, CardActions, CardContent, CardHeader, Grid, Typography} from "@mui/material";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {useTenantConfig} from "../../../security/tenant-config-context";

function ReservationPaid() {
    const navigate = useNavigate();
    const {user} = useAuth0();
    const { t } = useTranslation();
    const { cfg } = useTenantConfig();
    const isAppointmentFlow = cfg?.businessTypes?.includes('APPOINTMENT_BASED');

    return (
        <Grid container alignItems="center" justifyContent="center" spacing={1} sx={{textAlign: 'center'}}>
            <Grid item xs={12}>
                <Card variant="outlined">
                    <CardHeader title={<Typography color="secondary" variant="h5">{t('paymentSuccessTitle')}</Typography>}/>
                    <CardContent>
                        <Typography variant='p'>{t('paymentSuccessEmailNotice')}</Typography>
                        <Typography variant='p'> {user.email}</Typography>
                    </CardContent>
                    <CardActions style={{
                        display: 'flex',
                        justifyContent: 'center'
                    }}>
                        <Button variant="contained" onClick={() => navigate('/mijn-reservaties')}>
                            {isAppointmentFlow ? t('appointmentOverviewButton') : t('reservationOverviewButton')}
                        </Button>
                    </CardActions>
                </Card>
            </Grid>
        </Grid>
    )
}

export default withAuthenticationRequired(ReservationPaid, {
    onRedirecting: () => <Loading/>,
    returnTo: '/nieuwe-reservatie'
});
